
import React, { useState, useEffect } from "react";
import {
    Button,
} from "reactstrap";
import CartServices from "../../Services/CartServices";

const OtpChangeReceiver = ({activeTab, contactInfo, changeHandler }) => {

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="text-muted">{contactInfo}</div>
                <Button
                    color="link"
                    className="p-0 text-decoration-none"
                    onClick={() => changeHandler()}
                    type="button"
                >
                    Change {CartServices.isMobileTab(activeTab) ? "Number" : "Email"}
                </Button>
            </div>
        </>
    );
};

export default OtpChangeReceiver;
